import { api } from "../../../../services/api";

export async function openAllCashRegister({ companies, token, amount }) {
  await api.post("/openAllCashRegister", {
    companies,
    token,
    amount,
  });
}
